import React from "react";
import { Col, Row } from "reactstrap";

export const RepoteProyeccionDiaria = ({ data, campos, size, variedades }) => {
  return (
    <Row>
      {data.length > 0 && (
        <Col className="table-responsive">
          <table className="table table-bordered table-striped table-condensed table-sm">
            <thead>
              <tr>
                <th>Variedad</th>
                {campos.map((campo) => (
                  <th
                    key={campo.campo_id}
                    colSpan={size.length + 1}
                    style={{ textAlign: "center" }}
                  >
                    {campo.campo}
                  </th>
                ))}
                <th></th>
              </tr>
              <tr>
                <th></th>
                {campos.map((campo) => (
                  <React.Fragment key={`size_${campo.campo_id}`}>
                    {size.map((tamanio) => (
                      <th key={`${campo.campo_id}-${tamanio}`}>{tamanio}%</th>
                    ))}
                    <th>PROYECCIÓN</th>
                  </React.Fragment>
                ))}
                <th>TOTAL</th>
              </tr>
            </thead>
            <tbody>
              {variedades.map((variedad) => (
                <tr key={variedad.variedad_id}>
                  <td>{variedad.variedad}</td>

                  {campos.map((campo) => {
                    // Filtramos los items que correspondan a este campo y variedad
                    const item = data.find(
                      (d) =>
                        d.id_campo === campo.campo_id &&
                        d.id_variedad === variedad.variedad_id,
                    );

                    return (
                      <React.Fragment
                        key={`campo_${campo.campo_id}-${variedad.variedad_id}`}
                      >
                        {size.map((tamanio) => (
                          <td
                            key={`${campo.campo_id}-${variedad.variedad_id}-${tamanio}`}
                          >
                            {item ? item[tamanio] || 0 : 0}
                          </td>
                        ))}
                        <td
                          key={`total-${campo.campo_id}-${variedad.variedad_id}`}
                        >
                          {item ? item.total.toLocaleString() : 0}
                        </td>
                      </React.Fragment>
                    );
                  })}
                  <td>
                    {data
                      .filter(
                        (item) => item.id_variedad === variedad.variedad_id,
                      )
                      .reduce((sum, item) => sum + item.total, 0)
                      .toLocaleString()}
                  </td>
                </tr>
              ))}
              <tr>
                <td
                  colSpan={campos.length * (size.length + 1) + 1}
                  style={{ fontWeight: "bold", textAlign: "right" }}
                >
                  TOTAL
                </td>
                <td>
                  {data
                    .reduce((sum, item) => sum + item.total, 0)
                    .toLocaleString()}
                </td>
              </tr>
            </tbody>
          </table>
        </Col>
      )}
    </Row>
  );
};
